/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileType
 */
export interface FileType {
    /**
     * 
     * @type {number}
     * @memberof FileType
     */
    fileTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof FileType
     */
    fileType: string;
}

export function FileTypeFromJSON(json: any): FileType {
    return FileTypeFromJSONTyped(json, false);
}

export function FileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileTypeId': json['fileTypeId'],
        'fileType': json['fileType'],
    };
}

export function FileTypeToJSON(value?: FileType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileTypeId': value.fileTypeId,
        'fileType': value.fileType,
    };
}


